import { defineStore } from "pinia";

export const useFightSelectionStore = defineStore("fights-selection-store", {
    state() {
        return {
            selectedFightsToMove: {} as Record<number, boolean>,
            matIdToSelectFrom: null as number | null,
        };
    },
});
